import React, {useEffect, useState} from "react";
import "./SpinnerLoader.css"
import StarLoader from "../../assets/UI/star.png";



export default function SPLoader({ time }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!time) return; //  skip timer, but still call the hook

    const ms = time * 1000; // convert seconds → ms
    const timer = setTimeout(() => {
      setLoading(false);
    }, ms);

    return () => clearTimeout(timer);
  }, [time]);

  if (!loading) return null;

  return (
    <div className="loading-overlay">
      <img src={StarLoader} alt="Loading..." className="star-spinner" />
      <p className="loading-text">Loading</p>
    </div>
  );
}

//Resources:
    //How to Create Spinner Loader in React JS... by Codeburst
        //https://www.youtube.com/watch?v=aCbQUa7AmII